import React from 'react';
import {
  extend
} from '@thd-nucleus/data-sources';
import { MediaHotspots } from '@thd-olt-component-react/product-hotspots';
import { IntegratedBrandBathPropTypes } from './IntegratedBrandBathPropTypes';
import { BathCollectionData } from './IbtData';
import { MakeItMatchCollection } from './subcomponents/MakeItMatchCollection';
import { BathHeroCarousel } from './subcomponents/BathHeroCarousel';
import { ShopInspirationSection } from './subcomponents/ShopInspirationSection';
import { ShopByRoomSection } from './subcomponents/ShopByRoomSection';

export const IntegratedBrandBath = ({ collection, collectionId, storeId }) => {

  const bathPoCCollection = BathCollectionData.find((item) => item.collectionId === collectionId);
  const shopInspiration = bathPoCCollection?.shopInspiration;
  const shopByRoom = bathPoCCollection?.shopByRoom;
  const collectionDescription = collection?.metadata?.collectionDescription;
  const collectionName = collection?.metadata?.name;
  const brandName = collection?.metadata?.brandName;
  const imageURL = collection?.media?.images?.[0]?.url;
  const collectionImageURL = imageURL?.replaceAll('<SIZE>', '1000');
  const heroBannerSlides = [
    {
      brand: brandName, title: collectionName, description: collectionDescription, image: collectionImageURL
    },
  ];

  return (
    <div className="sui-grid sui-grid-flow-row-dense
      sui-grid-cols-12 sui-gap-y-10 sui-gap-x-4 md:sui-gap-x-6 lg:sui-gap-x-8"
    >
      <div className="sui-col-span-12">
        <BathHeroCarousel
          heroBannerSlides={heroBannerSlides}
          collectionName={collectionName}
          brandName={brandName}
        />
      </div>
      <div className="sui-col-span-12">
        <MakeItMatchCollection
          storeId={storeId}
          anchorId={bathPoCCollection?.anchorId}
          category="Bath"
        />
      </div>
      <ShopInspirationSection shopInspiration={shopInspiration} />
      {bathPoCCollection?.kitchenAnchorId && (
        <div className="sui-col-span-12">
          <MakeItMatchCollection
            storeId={storeId}
            anchorId={bathPoCCollection?.kitchenAnchorId}
            category="Kitchen"
          />
        </div>
      )}

      {shopByRoom?.length > 0 && (
        <div className="sui-col-span-12">
          <ShopByRoomSection shopByRoom={shopByRoom} />
        </div>
      )}
    </div>
  );
};

IntegratedBrandBath.propTypes = IntegratedBrandBathPropTypes;
IntegratedBrandBath.defaultProps = {
  collection: {}
};
IntegratedBrandBath.dataModel = extend({}, MakeItMatchCollection, MediaHotspots);